<template>
  <div class="col px-0 px-md-3">
    <ColorPointsHeader :message="pinkHeaderMessage" color="rgba(227, 13, 104, 0.5)" />
    <div id="catalogueBiens"
         class="py-5">
      <div id="barreRechercheBien"
           class="row center p-3">
        <b-form inline
                class="w-100 flex-column flex-sm-row justify-content-between"
                @submit.stop.prevent="obtenirBiens">
          <el-select
            v-if="display"
            v-model="bien.type"
            placeholder="Type de bien"
            class="critere bg-light rounded-0 mb-2 mb-xl-0 w-100 order-1"
            popper-class="bg-light type"
            id="typeBienSelecteur"
            name="type"
            multiple
            collapse-tags
            style="margin-left: 20px;">
            <el-option
              v-for="(item, idx) in typeBienOptions"
              :key="idx"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-select
            v-if="display"
            v-model="bien.nbrPieces"
            placeholder="Nbre de pièces"
            class="critere bg-light rounded-0 mb-2 mb-xl-0 order-2"
            popper-class="bg-light"
            id="nbrPiecesBienSelecteur"
            name="nbrPieces"
            multiple
            collapse-tags
            style="margin-left: 20px;">
            <el-option
              v-for="(item, idx) in nbrPiecesBiensOptions"
              :key="idx"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <div class="critere d-flex pr-3 mb-2 mb-xl-0 order-5 order-sm-3 order-xl-5">
            <p class="text-secondary my-auto ml-2 mr-3">Surface</p>
            <el-slider
              id="surfaceBien"
              name="surface"
              class="w-100 mt-auto mb-1 mx-auto"
              v-model="bien.surface"
              :min="0"
              :max="800"
              :step="5"
              range
              :marks="surfaceMarks"
              :format-tooltip="formatTooltipSurface">
            </el-slider>
          </div>
          <MultipleAutoComplete @changedGPSData="changeGPSData"></MultipleAutoComplete>
          <div class="critere d-flex flex-row mb-2 mb-xl-0 order-4"
              id="rayonBien">
            <p class="text-secondary my-auto ml-2">Rayon</p>
            <el-select
              v-if="display"
              v-model="bien.rayon"
              placeholder="Rayon"
              class="bg-light rounded-0 mb-2 mb-xl-0"
              popper-class="bg-light"
              name="rayon">
              <el-option
                v-for="(item, idx) in rayonBiensOptions"
                :key="idx"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <span id="km" class="bg-light border-left border-light input-group-text">km</span>
          </div>
          <div class="critere d-flex pr-3 mb-2 mb-xl-0 order-6">
            <p class="text-secondary my-auto ml-2 mr-3">Budget</p>
            <el-slider
              id="budgetBien"
              name="budget"
              class="w-100 mt-auto mb-1 mx-auto"
              v-model="bien.budget"
              :min="0"
              :max="1500000"
              :step="5000"
              range
              :marks="budgetMarks"
              :format-tooltip="formatTooltipBudget">
            </el-slider>
          </div>
          <b-button
            id="Rechercher"
            type="submit"
            variant="secondary"
            class="openSans-bold border border-secondary ml-0 ml-sm-auto mb-2 mb-xl-0 small-ls text-uppercase order-last"
            squared>
            Rechercher
          </b-button>
          <bien-alert-email :bien="bien" class="order-last m-2"></bien-alert-email>
        </b-form>
      </div>
      <div id="toolBar"
           class="row center align-items-center px-3 pt-3 border-bottom border-secondary">
        <p class="col-12 col-sm-auto mb-3 mb-sm-0 text-secondary bold small-ls m-0 d-flex justify-content-center align-items-center pl-0 pr-3">Trier par</p>
        <div class="col-12 col-sm-auto mb-3 mb-sm-0 text-center px-0">
          <div class="border border-dark d-inline-block">
            <el-select
              v-if="display"
              v-model="critereTri1"
              placeholder="Critère de tri"
              class="d-inline-block"
              popper-class="text-dark"
              id="triParCritere1"
              name="triParCritere1"
              @change="obtenirBiens">
              <el-option
                v-for="(item, idx) in criteres"
                :disabled="item.value === critereTri2"
                :key="idx"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="col-12 col-sm-auto mb-3 mb-sm-0 text-center px-0">
          <div class="border border-dark d-inline-block">
            <el-select
              v-if="display"
              v-model="critereTri2"
              placeholder="Critère de tri"
              class="d-inline-block"
              popper-class="text-dark"
              id="triParCritere2"
              name="triParCritere2"
              @change="obtenirBiens">
              <el-option
                v-for="(item, idx) in criteres"
                :disabled="item.value === critereTri1"
                :key="idx"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <b-pagination class="col-auto text-center px-0 mx-auto mx-sm-0 ml-sm-auto my-0"
                      size="md"
                      :total-rows="nbreBiens"
                      v-model="currentPage"
                      :per-page="biensPerPage">
          <template #page="{ page, active }">
            <p v-if="active" class="openSans-bold">{{ page }}</p>
            <p v-else class="openSans-light">{{ page }}</p>
          </template>
        </b-pagination>
      </div>
      <div id="listBiens" class="row center">
        <bien-preview v-for="(bien, idx) in biens" :key="idx" :bien="bien"></bien-preview>
        <div v-if="biensEmpty" class="col-12 p-4 p-sm-2 mb-4 mb-md-0">
          <h3 class="text-secondary">Nous n'avons aucun bien correspondant à votre recherche</h3>
        </div>
      </div>
      <div class="row center mx-4 border-top border-secondary">
        <b-pagination class="ml-auto my-0"
                      size="md"
                      :total-rows="nbreBiens"
                      v-model="currentPage"
                      :per-page="biensPerPage">
          <template #page="{ page, active }">
            <p v-if="active" class="openSans-bold">{{ page }}</p>
            <p v-else class="openSans-light">{{ page }}</p>
          </template>
        </b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { FormPlugin, FormInputPlugin, InputGroupPlugin, ButtonPlugin, PaginationPlugin } from 'bootstrap-vue'
import DataApi from 'fm-data-api'
import { getFocus } from '../../mixins/getFocus'

Vue.use(FormPlugin)
Vue.use(FormInputPlugin)
Vue.use(InputGroupPlugin)
Vue.use(ButtonPlugin)
Vue.use(PaginationPlugin)

export default {
  name: 'Achat',
  mixins: [getFocus],
  components: {
    ColorPointsHeader: () => import('../../components/ColorPointsHeader'),
    MultipleAutoComplete: () => import('../../components/MultipleAutoComplete'),
    BienPreview: () => import('../../components/BienPreview.vue'),
    BienAlertEmail: () => import('../../components/BienAlertEmail.vue')
  },
  data () {
    return {
      showAlertEmail: false,
      display: false,
      biens: {},
      biensEmpty: false,
      dataApi: null,
      focus: {},
      // variables actuelles de la barre de recherche
      bien: {
        type: null,
        nbrPieces: null,
        surface: null,
        coordinates: null,
        rayon: '20',
        budget: null
      },
      pinkHeaderMessage: {
        titre: '',
        sousTitre: ''
      },
      // dernières variables de la barre de recherche pour comparaison
      oldBien: {
        type: null,
        nbrPieces: null,
        surface: null,
        coordinates: null,
        rayon: null,
        budget: null
      },
      typeBienOptions: [
        { value: 'Maison / Villa', label: 'Maison / Villa' },
        { value: 'Appartement', label: 'Appartement' },
        { value: 'Terrain', label: 'Terrain' },
        { value: 'Commerce', label: 'Commerce' },
        { value: 'Bureau / Local commercial', label: 'Bureau / Local commercial' },
        { value: 'Parking', label: 'Parking' },
        { value: 'Immeuble', label: 'Immeuble' },
        { value: 'Hangar', label: 'Hangar' },
        { value: 'Hôtel particulier', label: 'Hôtel particulier' },
        { value: 'Droit au bail', label: 'Droit au bail' },
        { value: 'Divers', label: 'Divers' }
      ],
      nbrPiecesBiensOptions: [
        { value: '1', label: '1' },
        { value: '2', label: '2' },
        { value: '3', label: '3' },
        { value: '4', label: '4' },
        { value: '5', label: '5' },
        { value: '6', label: '6' },
        { value: '7', label: '7' },
        { value: '8', label: '8' }
      ],
      rayonBiensOptions: [
        { value: '5', label: '5' },
        { value: '10', label: '10' },
        { value: '20', label: '20' },
        { value: '50', label: '50' }
      ],
      surfaceMarks: {
        0: {
          style: {
            color: '#49507B'
          },
          label: this.$createElement('small', '0m²')
        },
        800: {
          style: {
            color: '#49507B'
          },
          label: this.$createElement('small', '800m²')
        }
      },
      budgetMarks: {
        0: {
          style: {
            color: '#49507B'
          },
          label: this.$createElement('small', '0 €')
        },
        1500000: {
          style: {
            color: '#49507B'
          },
          label: this.$createElement('small', '1 500 000 €')
        }
      },
      // variables des critères de recherche (configiration initiale)
      criteres: [
        {
          label: 'Date',
          value: 'd_dateAnnonce'
        },
        {
          label: 'Prix',
          value: 'd_prix'
        },
        {
          label: 'Surface',
          value: 'd_surface'
        },
        {
          label: 'Nbre de pièces',
          value: 'd_nbrePieces'
        },
        {
          label: 'Commune',
          value: 'd_commune'
        }
      ],
      critereTri1: 'd_dateAnnonce',
      critereTri2: 'd_prix',
      // Éléments configurant la pagination
      currentPage: 1,
      nbreBiens: 0,
      biensPerPage: 9
    }
  },
  props: {
    typeSearched: String,
    default: null
  },
  computed: {
    offset: function () {
      const offset = ((this.currentPage - 1) * this.biensPerPage).toString()
      return offset
    }
  },
  watch: {
    currentPage: function (val, oldVal) {
      this.obtenirBiens()
    }
  },
  methods: {
    async obtenirBiens () {
      const sort = []
      if (this.critereTri1 !== '' && this.critereTri1 !== null) {
        sort.push(
          {
            fieldName: this.critereTri1,
            sortOrder: 'descend'
          }
        )
      }

      if (this.critereTri2 !== '' && this.critereTri2 !== null) {
        sort.push(
          {
            fieldName: this.critereTri2,
            sortOrder: 'descend'
          }
        )
      }
      let sortToSend = JSON.stringify(sort)
      sortToSend = JSON.parse(sortToSend)
      const arrayFields = []
      let typeSearched = ''
      if (this.bien.type.length <= 1) {
        typeSearched = (this.bien.type.length === 0) ? 'bien' : this.bien.type[0]
      } else {
        typeSearched = 'bien'
      }
      if (window.location.href.split('/TI')[1] !== `/achat/${this.$options.filters.camelCase(typeSearched)}.html`) {
        this.$router.replace(`${this.$options.filters.camelCase(typeSearched)}.html`)
      }
      let query = []
      if (this.bien.type.length > 0) {
        this.bien.type.forEach(v => {
          const type = v
          if (this.bien.nbrPieces.length > 0) {
            this.bien.nbrPieces.forEach(val => {
              const arrayFields = []
              arrayFields.push({ fieldname: 'd_type', fieldvalue: `==${type}` })
              arrayFields.push({ fieldname: 'd_nbrPieces', fieldvalue: val })
              if (this.bien.surface[0].toString() !== Object.entries(this.surfaceMarks)[0][0] || this.bien.surface[1].toString() !== Object.entries(this.surfaceMarks)[1][0]) {
                arrayFields.push({ fieldname: 'd_surface', fieldvalue: `${this.bien.surface[0]}...${this.bien.surface[1]}` })
              }
              if (this.bien.budget[0].toString() !== Object.entries(this.budgetMarks)[0][0] || this.bien.budget[1].toString() !== Object.entries(this.budgetMarks)[1][0]) {
                arrayFields.push({ fieldname: 'd_prix', fieldvalue: `${this.bien.budget[0]}...${this.bien.budget[1]}` })
              }
              if (arrayFields.length > 0) {
                query.push({ fields: arrayFields })
              }
            }, this)
          } else {
            const arrayFields = []
            arrayFields.push({ fieldname: 'd_type', fieldvalue: `==${type}` })
            if (this.bien.surface[0].toString() !== Object.entries(this.surfaceMarks)[0][0] || this.bien.surface[1].toString() !== Object.entries(this.surfaceMarks)[1][0]) {
              arrayFields.push({ fieldname: 'd_surface', fieldvalue: `${this.bien.surface[0]}...${this.bien.surface[1]}` })
            }
            if (this.bien.budget[0].toString() !== Object.entries(this.budgetMarks)[0][0] || this.bien.budget[1].toString() !== Object.entries(this.budgetMarks)[1][0]) {
              arrayFields.push({ fieldname: 'd_prix', fieldvalue: `${this.bien.budget[0]}...${this.bien.budget[1]}` })
            }
            if (arrayFields.length > 0) {
              query.push({ fields: arrayFields })
            }
          }
        }, this)
      } else {
        if (this.bien.nbrPieces.length > 0) {
          this.bien.nbrPieces.forEach(val => {
            const arrayFields = []
            arrayFields.push({ fieldname: 'd_nbrPieces', fieldvalue: val })
            if (this.bien.surface[0].toString() !== Object.entries(this.surfaceMarks)[0][0] || this.bien.surface[1].toString() !== Object.entries(this.surfaceMarks)[1][0]) {
              arrayFields.push({ fieldname: 'd_surface', fieldvalue: `${this.bien.surface[0]}...${this.bien.surface[1]}` })
            }
            if (this.bien.budget[0].toString() !== Object.entries(this.budgetMarks)[0][0] || this.bien.budget[1].toString() !== Object.entries(this.budgetMarks)[1][0]) {
              arrayFields.push({ fieldname: 'd_prix', fieldvalue: `${this.bien.budget[0]}...${this.bien.budget[1]}` })
            }
            if (arrayFields.length > 0) {
              query.push({ fields: arrayFields })
            }
          }, this)
        } else {
          if (this.bien.surface[0].toString() !== Object.entries(this.surfaceMarks)[0][0] || this.bien.surface[1].toString() !== Object.entries(this.surfaceMarks)[1][0]) {
            arrayFields.push({ fieldname: 'd_surface', fieldvalue: `${this.bien.surface[0]}...${this.bien.surface[1]}` })
          }
          if (this.bien.budget[0].toString() !== Object.entries(this.budgetMarks)[0][0] || this.bien.budget[1].toString() !== Object.entries(this.budgetMarks)[1][0]) {
            arrayFields.push({ fieldname: 'd_prix', fieldvalue: `${this.bien.budget[0]}...${this.bien.budget[1]}` })
          }
          if (arrayFields.length > 0) {
            query.push({ fields: arrayFields })
          }
        }
      }

      if (this.bien.coordinates !== null && this.bien.coordinates) {
        let coordinatesArray = this.bien.coordinates.split('@')
        await this.dataApi.setGlobalFields('', {
          "ANN__Annonce::g_latLieu": coordinatesArray[0],
          "ANN__Annonce::g_lonLieu": coordinatesArray[1],
          "ANN__Annonce::g_rayonLieu": this.bien.rayon
        })
        if (query.length) {
          query[0].fields.push({
            fieldname: 'd_dansLaZoneDeRecherche',
            fieldvalue: 1
          })
        } else {
          query.push({ 
            fields: [{
              fieldname: 'd_dansLaZoneDeRecherche',
              fieldvalue: 1
            }] 
          })
        }
      }
      
      // instancie un getRecords si aucun paramètre de requête, un findRecords sinon
      if (query.length > 0) {
        query = JSON.stringify(query)
        query = JSON.parse(query)
        this.dataApi.findRecords('W_Annonce', query, sortToSend, this.offset, this.biensPerPage.toString(), [], [], true)
          .then((response) => {
            this.nbreBiens = (response.dataInfo === undefined) ? 0 : response.dataInfo.foundCount
            response.data = Vue.removeLayout(response.data)
            this.insertBiens(response.data)
          })
      } else {
        this.dataApi.getRecords('W_Annonce', sortToSend, this.offset, this.biensPerPage.toString(), [], [], true)
          .then((response) => {
            this.nbreBiens = (response.dataInfo === undefined) ? 0 : response.dataInfo.foundCount
            response.data = Vue.removeLayout(response.data)
            this.insertBiens(response.data)
          })
      }
    },
    insertBiens (biensL) {
      const biensList = (biensL === undefined) ? [] : biensL

      if (Object.values(biensList).length > 0) {
        this.biensEmpty = false
        const biensToInsert = {}
        Object.entries(biensList).forEach(function ([index, value]) {
          const dataToInsert = value.fieldData
          dataToInsert.recordId = value.recordId
          biensToInsert[index] = dataToInsert
        })
        this.biens = biensToInsert
      } else {
        this.biensEmpty = true
        this.biens = {}
      }
    },
    getbienLink (type, recordId) {
      const camelCasedType = this.$options.filters.camelCase(type)
      return `TI/achat/${camelCasedType}/${recordId}.html`
    },
    changeGPSData (coordinates, cityNames) {
      this.bien.coordinates = coordinates
      this.bien.cityNames = cityNames
    },
    async loadBiens () {
      const options = {
        apiUrl: this.$apiUrl,
        databaseName: this.$databaseName,
        token: await this.$getMainToken()
      }
      this.dataApi = new DataApi(options)
      const sortToSend = [
        {
          fieldName: this.critereTri1,
          sortOrder: 'descend'
        },
        {
          fieldName: this.critereTri2,
          sortOrder: 'descend'
        }
      ]
      const type = this.bien.type
      if (type.length === 0) {
        this.dataApi.getRecords('W_Annonce', sortToSend, 0, this.biensPerPage.toString(), [], [], true)
          .then((response) => {
            this.nbreBiens = (response.dataInfo === undefined) ? 0 : response.dataInfo.foundCount
            this.insertBiens(response.data)
            this.display = true
          })
      } else {
        const query = [
          {
            fields: [
              { fieldname: 'd_type', fieldvalue: this.bien.type[0] }
            ]
          }
        ]
        this.dataApi.findRecords('W_Annonce', query, sortToSend, 0, this.biensPerPage.toString(), [], [], true)
          .then((response) => {
            this.nbreBiens = (response.dataInfo === undefined) ? 0 : response.dataInfo.foundCount
            response.data = Vue.removeLayout(response.data)
            this.insertBiens(response.data)
            this.display = true
          })
      }
    },
    formatTooltipSurface (value) {
      return value + 'm'
    },
    formatTooltipBudget (value) {
      value = parseInt(value)
      if (value < 999) {
        return value + ' €'
      }
      return this.$options.filters.formatMoney(value) + ' €'
    },
    classStatus (value) {
      // "En vente" + "Sous offre" + "Sous compromis" + "Vendu"
      if (value !== '' && value !== undefined) {
        return this.$options.filters.camelCase(value)
      }
      return ''
    }
  },
  async beforeMount () {
    switch (this.typeSearched) {
      case 'bien':
        this.bien.type = []
        break
      case 'maisonVilla':
        this.bien.type = ['Maison / Villa']
        break
      case 'droitAuBail':
        this.bien.type = ['Droit au bail']
        break
      case 'bureauLocalCommercial':
        this.bien.type = ['Bureau / Local commercial']
        break
      case 'hotelParticulier':
        this.bien.type = ['Hôtel particulier']
        break
      default:
        this.bien.type = this.$options.filters.capitalize(this.typeSearched)
    }
    this.loadBiens()

    await this.getFocus('Tolus Immo', 'Achat')
      .then(res => {
        this.focus = res
          this.pinkHeaderMessage.titre = this.focus.cartouche ? this.focus.cartouche.titre : ''
          this.pinkHeaderMessage.sousTitre = this.focus.cartouche ? this.focus.cartouche.texte : ''
      })
  }
}
</script>

<style lang="scss" scoped>

  $critere: 3.2rem;

  ::v-deep .el-icon-close {
    right: 0 !important ;
  }

  ::v-deep .el-icon-arrow-up:before {
    content: '\2303';
    vertical-align: bottom !important;
    margin-top: 0.5rem !important;
    font-weight: bolder !important;
    font-size: 1.5rem !important;
  }

  ::v-deep .el-icon-close:before {
    content: '\2716';
  }

  ::v-deep .el-select-dropdown.type {
    width: 15rem !important;
  }

  .el-select-dropdown {
    .el-select-dropdown__item {
      padding: 0 3rem 0 0.5rem !important;
      width: 100% !important;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .el-select-dropdown__item.selected {
      max-width: 99%;
      display: flex !important;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .el-select-dropdown__item.selected::after {
      content: '\2713';
      right: 0.5rem;
      position: absolute !important;
      font-family: element-icons;
      font-size: 12px;
      font-weight: 700;
    }
  }
  .el-select-dropdown.bg-light {
    .el-select-dropdown__item.selected {
      color: var(--secondary);
    }
    .el-select-dropdown__item.hover {
      background-color: var(--pink) !important;
      color: var(--secondary) !important;
    }
  }
  #barreRechercheBien {
    .critere {
      border: 1px solid var(--secondary) !important;
    }

    ::v-deep .el-select {
      height: $critere !important;
    }

    ::v-deep .el-icon-close {
      background-color: var(--pink) !important;
    }

    ::v-deep .el-tag.el-tag--info .el-tag__close {
      color: var(--light) !important;
    }

    ::v-deep .el-icon-arrow-up:before {
      color: var(--secondary) !important;
    }
  }

  .el-select-dropdown.text-dark {
    .el-select-dropdown__item {
      margin: 0 !important;
      width: 100% !important;
    }
    .el-select-dropdown__item.is-disabled {
      color: var(--gray) !important;
    }
    .el-select-dropdown__item.selected,
    .el-select-dropdown__item.hover {
      color: var(--dark) !important;
      background-color: var(--light) !important;
    }
  }

  ::v-deep .el-tag.el-tag--info {
    background-color: var(--pink);
    border-color: var(--secondary);
    color: var(--secondary);
  }

  ::v-deep .el-select {
    margin-right: 0 !important;
    margin-left: 0 !important;
    .el-tag {
      margin: 0 auto !important;
    }
    .el-select__tags {
      position: absolute;
      line-height: normal;
      white-space: normal;
      z-index: 1;
      top: 50%;
      transform: translateY(-50%);
      align-items: center;
      flex-wrap: wrap;
      display: flex !important;
      flex-direction: row !important;
      height: 100% !important;
      max-width: 100% !important;
      span {
        padding: 0.2rem 0 !important;
        width: 60% !important;
        height: 100% !important;
        display: flex !important;
        flex-direction: row !important;
        align-items: center;
        span {
          margin: auto 0 auto 0.25rem !important;
        }
        >span:first-of-type {
          width: 100% !important;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        >span:nth-of-type(2) {
          max-width: 2.4rem;
        }
      }
    }
    .el-select__input {
      margin-left: 0.5rem !important;
    }
    .el-input {
      height: 100% !important;
      width: 100% !important;
    }
    .el-input__inner {
      color: var(--secondary) !important;
      padding-right: 0 !important;
      padding-left: 0.5rem !important;
      height: 100% !important;
      border: none !important;
      border-radius: 0 !important;
    }
  }

  #rayonBien {
    #km {
      width: 3rem !important;
      padding: 0 auto !important;
    }
    ::v-deep .el-select {
      width: 4rem !important;
      margin-right: 0 !important;
      border: none !important;
    }
  }

  @media (max-width: 575px) {
    #barreRechercheBien {
      .critere,
      #Rechercher {
        width: 70% !important;
        max-width: 12rem !important ;
      }
    }
    #rayonBien {
      ::v-deep .el-select {
        margin-left: auto !important;
      }
    }
  }

  @media (min-width: 576px) and (max-width: 991px) {
    #barreRechercheBien {
      .critere {
        width: 30% !important;
      }

    }
  }

  @media (min-width: 992px) {
    #barreRechercheBien {
      .critere {
        width: 15% !important;
      }
    }
  }

  #barreRechercheBien {
    .form-control {
      background-color: var(--light) !important;
      border: none !important;
      color: var(--secondary) !important;
      font-size: 1rem !important;
    }

    .input-group-text {
      border-radius: 0px !important;
    }

    .critere {
      height: $critere !important;
      overflow: hidden;
    }

    button[type="submit"] {
      min-width: 8rem !important;
    }

    .autoCompleteInput input,
    .autoCompleteInput .input-group {
      height: 100% !important;
      border-radius: 0;
    }

    ::v-deep input::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
      font-size: 1rem !important;
      color :var(--secondary) !important;
      opacity: 1 !important ; /* Firefox */
    }
  }

  #toolBar {
    ::v-deep .el-icon-arrow-up:before {
      color: var(--dark) !important;
      position: relative;
      bottom: 0.5rem !important;
    }

    >.border-dark {
      height: 1.7rem !important;
    }

    ::v-deep .el-select {
      .el-input--suffix {
        height: 100% !important;
      }
      .el-input {
        height: 1.5rem !important;
      }
      .el-input__inner {
        color: var(--dark) !important;
      }
    }
    .pagination {
      height: 3rem !important;
    }
  }

  #Rechercher {
    height: $critere !important;
  }

  @media (max-width: 575px) {
    #barreRechercheBien {
      .critere {
        width: 70% !important;
        max-width: 12rem !important ;
      }
    }
  }

  @media (min-width: 576px) and (max-width: 1199px) {
    #barreRechercheBien {
      .critere {
        width: 33.33% !important;
      }
    }
  }

  @media (min-width: 1200px) {
    #barreRechercheBien {
      .critere {
        width: calc((100% - 8rem + 6px) / 6) !important;
        margin-right: -1px !important;
      }
    }
  }

  ::v-deep .page-link {
    color: var(--dark) !important;
    background-color: transparent !important;
    border: none !important;
  }

  .fa-eye {
    background-image: url("../../assets/images/picto-oeil.svg");
    background-size: 100% 100% !important;
  }

  ::v-deep .el-slider__runway {
    margin: 5px 0 !important;
    bottom: 0 !important;
  }
  ::v-deep .el-slider__marks-text {
    white-space: nowrap !important;
    margin-top: -2rem !important;
  }

  ::v-deep .el-slider__marks-text:first-of-type {
    transform: translateX(-50%) !important;
  }

  ::v-deep .el-slider__marks-text:last-of-type {
    transform: translateX(-90%) !important;
  }

  #surfaceBien {
    .el-slider__marks-text strong::after {
      content: "2";
      font-size: 80%;
      vertical-align: super;
    }
  }

  ::v-deep .el-slider__bar {
    background-color: var(--secondary) !important;
  }
  ::v-deep .el-slider__button {
    border-color: var(--secondary) !important;
  }

  .bien {
    height: 32rem !important;
    overflow: hidden;
    img {
      max-height: 50% !important;
      position: relative;
    }
    .bandeau {
      transform: rotate(45deg);
    }
    .bandeau.sousOffre {
      top: 2rem;
      right: -2rem;
    }
    .bandeau.sousCompromis {
      top: 3rem;
      right: -2rem;
    }
    .bandeau.vendu {
      top: 0.8rem;
      right: -2rem;
    }
    .bandeau::after {
      padding: 0rem 2rem !important;
    }
    .bandeau.sousOffre::after {
      content: 'Sous offre';
      background-color: yellow;
      color: black !important;
    }
    .bandeau.sousCompromis::after {
      content: 'Sous compromis';
      background-color: orange;
      color: white !important;
    }
    .bandeau.vendu::after {
      content: 'Vendu';
      background-color: red;
      color: white !important;
    }
    .fai {
      height: 2.7rem !important;
    }
  }
  .alertEmailForm {
    position: fixed; /* Stay in place */
    z-index: 1050; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0,0,0); /* Fallback color */
    background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
  }
  /* Modal Content/Box */
  .modal-content {
    background-color: #fefefe;
    margin: 15% auto; /* 15% from the top and centered */
    padding: 20px;
    border: 1px solid #888;
    width: 80%; /* Could be more or less, depending on screen size */
  }
</style>
